<template>
  <div id="body">
    <!--遮罩层-->
    <!-- <div v-if="this.isWxNavigator" id="body1">
      <div><img alt="指引" class="body1-img" src="../assets/57@3x.png"></div>
      <div id="font1" class="body1-font">点击右上角</div>
      <div id="font2" class="body1-font">用浏览器打开并下载</div>
    </div> -->

    <div v-if="type === 2">
      <div id="head">
        <div class="title">
          <div id="title-img"><img alt="" class="img" src="../assets/tpWarn@3x.png"></div>
          <div id="title-font">关注公众号</div>
        </div>
        <div id="title2">
          线上激活电子保修卡
        </div>
        <div class="code">
          <img alt="二维码" class="code-img" src="../assets/code.jpg">
        </div>
        <div class="title4">
          长按识别图中二维码
        </div>
      </div>
    </div>
    <div v-if="type === 1">
      <div style="color: #2b3335">
        <div id="head2">
          <!-- <div class="title" style="display: flex;justify-content: center;align-items: center;" v-show="isResponse">
            <div class="title-img1" v-if="!notInStorage_code"><img alt="" class="img" :src="appLogo ? appLogo : '/static/AppIcon.png'"></div>
            <div class="title-font2">
              <div>
                欢迎使用{{AppName}}
              </div>
              <div>
                打开小程序查看车辆状态
              </div>
            </div>
          </div> -->
          <div v-if="notInStorage_code">{{lang.product}} SN：{{notInStorage_code}} {{lang.notInStock}}</div>
          <div class="main_block"> 
            <div class="plate_block">
              <div v-if="infoObj && infoObj.entName" class="ent_info">
                <img :src="infoObj.entLogo" v-if="infoObj.entLogo" :class="!infoObj.groupName ? 'mini_logo': ''"/>
                <div class="ent_info_right">
                  <p>{{infoObj.entName}}</p>
                  <p v-if="infoObj.groupName">{{infoObj.groupName}}</p>
                </div>
              </div>
              <!-- 「SN：{{snCode}}」 -->
              <div><span style="font-weight: 600">{{parentNumber}}</span> {{lang.device}} SN：{{snCode}}</div>
              <template v-if="plate">
                <div v-if="snCode && snCode.slice(-6) == plate">{{lang.temporarilyPlate}}</div>
                <div v-else>{{lang.plate}}</div>
                <div class="plate_text">{{plate}}</div>
              </template>
            </div>
            <template v-if="isWxNavigator && Boolean(AppletPrimitiveId)">
              <!-- env-version="trial" -->
              <!-- :path="sn?'pages/tabBar/home.html?sn='+sn:'pages/tabBar/home.html'" -->
              <wx-open-launch-weapp
                id="launch-btn"
                :username="AppletPrimitiveId"
                :path="pageUrl"
                @launch="handleLaunchFn"
                @error="handleErrorFn"
                style="width: 250px;"
              >
                <script type="text/wxtag-template">
                  <style>
                    .open{
                      padding: 15px;
                      text-align: center;
                      margin-top: 100px;
                    }
                    .btn{
                      width: 200px;
                      background-color: #19be6b;
                      color: white;
                      padding: 10px 30px;
                      border: none;
                      border-radius: 10px;
                      font-size: 20px;
                    }
                  </style>
                  <div class="open">
                    <button class="btn">{{lang.openWsProgram}}</button>
                  </div>
                </script>
              </wx-open-launch-weapp>
              <wx-open-launch-weapp
                :username="AppletPrimitiveId"
                :path="transferUrl"
                @launch="handleLaunchFn"
                @error="handleErrorFn"
                style="width: 250px;"
                v-if="transferUrl"
              >
                <script type="text/wxtag-template">
                  <style>
                    .open_btn{
                      padding: 15px;
                      text-align: center;
                      margin-top: 30px;
                    }
                    .btn{
                      width: 200px;
                      background-color: #19be6b;
                      color: white;
                      padding: 10px 30px;
                      border: none;
                      border-radius: 10px;
                      font-size: 20px;
                    }
                  </style>
                  <div class="open_btn">
                    <button class="btn">{{lang.deviceMigration}}</button>
                  </div>
                </script>
              </wx-open-launch-weapp>
              <wx-open-launch-weapp
                :username="AppletPrimitiveId"
                :path="swapTrailerUrl"
                @launch="handleLaunchFn"
                @error="handleErrorFn"
                style="width: 250px;"
                v-if="swapTrailerUrl"
              >
                <script type="text/wxtag-template">
                  <style>
                    .open_btn{
                      padding: 15px;
                      text-align: center;
                      margin-top: 30px;
                    }
                    .btn{
                      width: 200px;
                      background-color: #19be6b;
                      color: white;
                      padding: 10px 30px;
                      border: none;
                      border-radius: 10px;
                      font-size: 20px;
                    }
                  </style>
                  <div class="open_btn">
                    <button class="btn">{{lang.swap}}</button>
                  </div>
                </script>
              </wx-open-launch-weapp>
            </template>
            <div class="app_block" v-if="!isWxNavigator">
              <img class="app_logo" src="@/assets/appLogo.png" />
              <div class="app_info">
                <h3>TyreDefender App</h3>
                <div class="app_btn">
                  <a id="openApp" class="app_install open_app" :href="schemeUrl">{{lang.open}}</a>
                  <a class="app_install" v-if="isiPhone" href="https://apps.apple.com/cn/app/tyredefender/id6747969481">
                    {{lang.download}}
                  </a>
                  <a class="app_install" v-else href="https://toro-cv.e5ex.cn/tpms/1812/071810493968/__UNI__EDB3E70_0715180721.apk">
                    {{lang.download}}
                  </a>
                </div>
              </div>
            </div>
            <!-- <a class="product_link" v-if="parentNumber" :href="'https://tapi.e5ex.com/product?p='+parentNumber"> -->
            <!-- <a class="product_link" v-if="parentNumber" :href="'https://tapi.e5ex.com/product?p='+(parentNumber.includes('R9') ? 'R90' : parentNumber)"> -->
            <a class="product_link" v-if="parentNumber && work_url" :href="work_url">
              {{lang.view}} {{parentNumber}} {{lang.productIntroduction}}
            </a>
            <a v-if="!isWxNavigator && wxLink" class="wx_btn product_link" :href="`https://servicewechat.com/wxascheme/jump_wxa?url=${wxLink}`">
              {{lang.openWsProgram}}
            </a>
          </div>
          <!-- <div v-if="!isWxNavigator" class="code">
            <div style="font-size: 18px;color: rgba(0, 0, 0, 1);padding-top: 15px;">
              请使用微信打开
            </div>
          </div> -->
          <!-- <div v-else class="code">
            <img :src="this.downUrl" alt="二维码" class="code-img">
            <div style="font-size: 18px;color: rgba(0, 0, 0, 1);padding-top: 15px;">
              请保存二维码，在微信中识别
            </div>
          </div> -->
        </div>
      </div>
      <!-- <div v-if="AppName == 'TORO'" class="button" style="border-top:1px solid #767474" v-on:click="gotoType()">
        电子保修卡
        <div class="symbol">></div>
      </div> -->
    </div>
  </div>
</template>
<script>
import {getSign,imeiSn} from '../api/api';
export default {
  data() {
    return {
      infoObj: {},
      schemeUrl: 'toroApp://',
      work_url: '',
      transferUrl: '',
      swapTrailerUrl: '',
      wxLink: '',
      pageUrl: '',
      hrefUrl: '',
      appLogo: '',
      isiPhone: true,
      isWxNavigator: true,
      type: 1,
      explainUrl: '',
      downUrl: 'https://cv.e5ex.cn/app/qrCode/iphone.png',
      sn: "",
      AppletPrimitiveId: "",
      notInStorage_code: "",
      AppName: "",
      snCode: "",
      plate: "",
      parentNumber: "",
      isResponse: false
    };
  },
  computed: {
    lang(){
      const localLang = ((navigator.language ? navigator.language : navigator.userLanguage) || "zh").split('-')[0].toLowerCase();
      let obj = {
        product: '产品',
        notInStock: '未入库，请联系技术支持',
        device: '设备',
        temporarilyPlate: '临时绑定车牌',
        plate: '已绑定车牌',
        view: '查看',
        productIntroduction: '产品介绍',
        deviceMigration: '迁移设备',
        openWsProgram: '打开小程序',
        swap: '甩挂',
        download: '下载',
        open: '打开',
      }
      if(localLang != 'zh'){
        obj = {
          product: 'Product',
          notInStock: 'Not in stock, please contact technical support',
          device: 'Device',
          temporarilyPlate: 'Temporarily bound license plate',
          plate: 'Bound license plate',
          view: 'View',
          productIntroduction: 'Product Introduction',
          deviceMigration: 'Device Migration',
          openWsProgram: 'Open WeChat Mini Program',
          swap: 'Trailer Swap',
          download: 'Download',
          open: 'Open',
        }
      }
      return obj
    }
  },
  created() {
    this.checkViewport();
  },
  mounted(){
    this.ToMiniapp();
  },
  methods: {
    handleLaunchFn(e) {
      console.log('success', e.detail);
        // window.open("https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkzMTE4MDY5MA==#wechat_redirect");
    },
    handleErrorFn(e){
      console.log('fail', e.detail);
    },
    ToMiniapp() {
      // window.location.href.split('#')[0]
      // window.location.href.split('R')[1].substr(3,window.location.href.split('/#/')[1].length)
      let url = location.href.split('/#/')[0];
      let sn = location.href.split('/#/')[1];
      // 蓝牙版传感器【S9,B3/B8】
      if(sn.includes('?type=')){
        sn = 'S'+sn.split('?')[0].split('R')[1];
      }
      const params = {
        url: url,
        sn: sn,
      }
      getSign(params).then(({code, msg, data}) => {
        if (code === 0) {
          this.infoObj = data;
          this.AppletPrimitiveId = data.AppletPrimitiveId;
          this.AppName = data.AppName;
          this.pageUrl = data.page;
          this.wxLink = data.wxLink;
          this.schemeUrl = 'toroApp:///'+ data.page;
          this.transferUrl = data.transferUrl;
          // 甩挂
          this.swapTrailerUrl = data.swapTrailerUrl;
          this.isResponse = true;
          this.appLogo = data.logo;
          document.title = this.AppName;
          this.plate = data.plate;
          this.parentNumber = data.parentNumber;
          this.work_url = data.work_url;
          this.snCode = data.Sn;
          wx.config({
            debug: false,
            appId: "wxa897b31443ea9c96",
            signature: data.signature,
            nonceStr: data.nonceStr,
            timestamp: data.timestamp,
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
            openTagList: ["wx-open-launch-weapp"]
          });
          wx.ready(() => {
            console.log('wx ready')
            this.wxShareHandle('updateAppMessageShareData');
            // this.wxShareHandle('updateTimelineShareData');
          });
          wx.error(function (res) {
            console.log("error",res)
          });
          this.notInStorage_code = '';
        } else if (code == -2) {
          // 未入库的设备号
          // this.$message.error(`产品「SN：${data}」未入库，请联系技术支持`);
          this.notInStorage_code = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    wxShareHandle(action) {
      const params = {
        title: '分享标题3', // 分享标题
        desc: 'TORO 轮端感知车辆底盘安全卫士', // 分享描述
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://tpms-cv.oss-cn-shenzhen.aliyuncs.com/web/2401/12151256/S3%20%E5%B8%A6%E5%A3%B3%E5%A5%97-2.5.png', // 分享图标
      }
      if(['/df/','/mf/'].some(v => location.href.includes(v))){
        params.desc = '';
      }
      wx[action]({
        ...params,
        success: () => {
          // 设置成功
          console.log(action, '分享成功');
        },
        fail: (err) => {
          console.log(action, '分享失败', err);
        }
      })
    },
    // 查看当前配置
    checkViewport() {
      //判断设备 /R862177043673170
      let path = this.$router.currentRoute.path;
      this.sn = 'https://e5ex.com/'+window.location.href.split('/#/')[1];
      //下载APP
      if (path.substr(1, 1) === 'R' || path.substr(1, 4) === 'show') {
        this.type = 1;
      }
      //关注公众号
      else if (path.substr(1, 1) === 'A') {
        this.type = 2;
        this.sn = "";
      }
      let u = navigator.userAgent;
      let platform = navigator.platform;
      if (u.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
        this.isWxNavigator = true;
      }else{
        this.isWxNavigator = false;

        setTimeout(_=>{
          let a = document.querySelector('#openApp');
          if(a){
            a.click();
          }
        }, 2000)
      }

      //苹果浏览器
      this.isiPhone = Boolean(u.indexOf('iPhone') > -1);
    },
    gotoType() {
      this.type = 2;
    }
  }
}
</script>
<style scoped>
.app_block{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}
.app_logo{
  width: 80px;
  height: 80px;
  border-radius: 10px;
}
.app_info h3{
  margin: 15px 0;
  text-align: center;
}
.app_btn{
  display: flex;
  align-items: center;
}
.app_install{
  display: block;
  /* width: 50vw;
  margin: 30px auto; */
  width: 120px;
  margin: 0 15px;
  text-align: center;
  padding: 8px 0;
  border-radius: 10px;
  font-size: 16px;
  background-color: #fff;
  color: #4d70ff;
  border: 1px solid #ccc;
}
.open_app{
  background-color: #4d70ff;
  color: #fff;
  border: none;
}
.ent_info{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}
.ent_info>img{
  height: 45px;
  width: 45px;
  border-radius: 7.5px;
}
.ent_info>img.mini_logo{
  height: 25px;
  width: 25px;
}
.ent_info_right{
  margin-left: 10px;
  font-size: 16px;
  line-height: 25px;
}
.plate_block{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 50px;
}
.plate_text{
  padding: 5px 8px;
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin: 10px 0 0;
  width: auto;
  background-color: #fec922;
  text-align: center;
  border: 2px solid #000;
  border-radius: 8px;
}
.main_block{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.btn:active{
  background-color: rgba(25, 190, 107, 0.8);
}
.body1-img {
  position: absolute;
  height: 50px;
  width: 90px;
  right: 20px;
  top: 10px;
}
.product_link{
  display: block;
  width: 160px;
  padding: 10px;
  border-radius: 5px;
  color: #4d70ff;
  box-shadow: 0px -2px 10px 2px #CCCCCC;
  margin-top: 40px;
  text-align: center;
  line-height: 1.2;
}
.wx_btn{
  margin-top: 10px;
  color: #fff;
  box-shadow: none;
  background-color: #19be6b;
}

.body1-font {
  position: absolute;
  color: rgba(255, 255, 255, 0.87);
  font-size: 20px;
}

#font1 {
  top: 45px;
  right: 120px;
}

#font2 {
  top: 80px;
  right: 40px;
}

#body {
  height: 100%;
  width: 100%;
  position: absolute;
  background: url("../assets/back.jpg");
  background-size: 80%;
}

#body1 {
  position: fixed;
  background: rgba(0, 0, 0, 0.67);
  z-index: 1020000000000000;
  height: 100%;
  width: 100%;
}

#head {
  height: 320px;
  width: 200px;
  margin: 80px auto 40px;
}

#head2 {
  min-height: 280px;
  /* width: 250px; */
  padding: 0 20px;
  margin: 80px auto 0;
  position: relative;
}

.title {
  width: calc(100% + 2px);
  height: 40px;
  display: flex;
  align-items: center;
}

#title2 {
  width: 100%;
  height: 20px;
  margin: 15px 10px;
  font-size: 20px;
  color: #878787;
}

.title3 {
  width: 100%;
  height: 20px;
  margin: 15px 70px;
  font-size: 16px;
}

.title4 {
  width: 100%;
  height: 20px;
  margin: 15px 28px;
  font-size: 16px;
}

.img {
  height: 45px;
  width: 45px;
}

#title-img {
  float: left;
}

.title-img1 {
  float: left;
  display: flex;
  align-content: center;
}
.title-img1 > img{
  border-radius: 7.5px;
}

.title-font2 {
  font-family: Source Han Sans CN, sans-serif;
  float: left;
  font-size: 16px;
  line-height: 25px;
  margin-left: 8px;
  color: rgba(0, 0, 0, 1);
}

#title-font {
  font-family: Source Han Sans CN, sans-serif;
  float: right;
  font-weight: 1000;
  font-size: 30px;
  line-height: 40px;
}

.code {
  height: 180px;
  width: 100%;
  text-align: center;
  margin: 30px 0;
}

.code-img {
  height: 180px;
  width: 180px;
}

.button {
  height: 42px;
  width: 85%;
  margin: 0 auto auto;
  font-size: 20px;
  line-height: 40px;
  color: #808080;
}

.symbol {
  float: right;
  margin: auto 0;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/download.vue